import React from "react";
import { Text, View, StyleSheet, Platform } from "react-native";

import ImageComponent from "../common/ImageComponent";
import ManaButton from "../common/ManaButton";
import AppTheme from "../AppTheme";

export default function ReflectionTutorialCard({ onPress }) {
  return (
    <View style={styles.container}>
      <Text style={styles.cardText}>
        You can’t know where you’re going until you know where you’ve been
      </Text>

      <ManaButton
        isMainButton
        onPress={onPress}
        style={styles.button}
        styleText={styles.buttonText}
        text={"Reflect on Last Week"}
      />

      <ImageComponent
        image={require("../../../assets/home/ThisIsMana.png")}
        style={{ width: 197, maxHeight: 192 }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  cardText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontStyle: "italic",
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    textAlign: "center",
    marginVertical: 28,
    maxWidth: 300,
  },
  button: {
    width: 305,
    marginBottom: 19
  },
});
